/* eslint-disable @typescript-eslint/no-explicit-any */
import { Autocomplete, Grid, TextField } from "@mui/material";
import { ProductModel, TaxRateModel } from "../../Utils/Models";
import { Vocabulary } from "../../Utils/Vocabulary";
import DividerWithLabel from "../GenericComponents/DividerWithLabel";
import { TextValidator } from "react-material-ui-form-validator";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getData } from "../../Services/getData";
import { urlEnum } from "../../Utils/UrlEnum";
import { onChangeTextField } from "../../Utils/Utils";

type PriceProps = {
  product: ProductModel;
  handleChangeProduct: (product: ProductModel) => void;
};

export default function Price(props: PriceProps) {
  const { product, handleChangeProduct } = props;
  const [priceVAT, setPriceVAT] = useState<number>();
  const [commercialMarkup, setCommercialMarkup] = useState<number>(0);
  const [taxRates, setTaxRates] = useState([]);

  useEffect(() => {
    const getTaxRates = async () => {
      try {
        const data = await getData(`${urlEnum.taxRates}`);
        setTaxRates(data.data.result);
      } catch (error) {
        toast.error(`${error}`);
      }
    };
    getTaxRates();
    const data = localStorage.getItem("mainUser");
    if (data) {
      setCommercialMarkup(JSON.parse(data).commercialMarkup);
    }
  }, []);

  useEffect(() => {
    if (product.price && Number(product.price) !== 0) {
      setPriceVAT(
        product.vat.value
          ? Number(product.price) +
              (Number(product.price) * product.vat.value) / 100
          : Number(product.price)
      );
    } else if (Number(product.price) === 0) {
      setPriceVAT(0);
    }
  }, [product]);

  return (
    <Grid container spacing={2} style={{ marginTop: 20 }}>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <DividerWithLabel label={Vocabulary.selling} />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <TextValidator
          label={Vocabulary.priceWithoutVAT}
          name="price"
          value={product.price}
          onChange={(event:any)=>{
            handleChangeProduct(onChangeTextField(event,product));
          }}
          type="number"
          fullWidth
          validators={["required"]}
          errorMessages={["Phone is required"]}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <Autocomplete
          size="small"
          id="type"
          freeSolo={true}
          options={taxRates}
          value={product.vat}
          getOptionLabel={(option: any) => option.name}
          isOptionEqualToValue={(option: any, value: any) => option === value}
          getOptionDisabled={(option: TaxRateModel) => option === product.vat}
          onChange={async (event, value: any) => {
            handleChangeProduct({
              ...product,
              vat: value,
            });
          }}
          renderInput={(params: any) => (
            <TextValidator
              {...params}
              fullWidth
              label={Vocabulary.vat}
              variant="outlined"
              value={product.vat}
              validators={["required"]}
              errorMessages={[Vocabulary.requiredField]}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <TextField
          id="outlined-read-only-input"
          label={`${Vocabulary.priceWithVAT}`}
          defaultValue={0}
          value={priceVAT}
          InputProps={{
            readOnly: true,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <DividerWithLabel label={Vocabulary.purchase} />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <TextField
          id="outlined-read-only-input"
          label={Vocabulary.purchaseValue}
          value={priceVAT ? priceVAT + (priceVAT * commercialMarkup)/100 : 0}
          InputProps={{
            readOnly: true,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <TextField
          id="outlined-read-only-input"
          label={Vocabulary.purchaseValue}
          type="number"
          value={commercialMarkup}
          onChange={(event) => {
            setCommercialMarkup(Number(event.target.value));
          }}
        />
      </Grid>
    </Grid>
  );
}
